import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {Button as MuiButton, Grid, Typography} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import {Logo} from "../components/Logo";
import logo from "../../images/Logo4.png";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
  text-align: center;
  background: transparent;

  ${props => props.theme.breakpoints.up("md")} {
    padding: ${props => props.theme.spacing(10)}px;
  }
`;

function Page404() {
  const { t } = useTranslation('page404');

  return (
    <Wrapper>
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        {t('title')}
      </Typography>
      <Typography component="h2" variant="h5" align="center" gutterBottom>
        {t('pageNotFound')}
      </Typography>
      <Typography component="h2" variant="body1" align="center" gutterBottom>
        {t('pageRemoved')}
      </Typography>

      <Button
        component={Link}
        to="/"
        variant="contained"
        color="secondary"
        mt={2}
      >
        {t('returnToWebsite')}
      </Button>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
      <Grid item style={{paddingTop: 50}}>
          <Logo logo={logo} width={'45%'}/>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Page404;
